export const clickResetHandler = (
    canvasWidth: number, canvasHeight: number, 
    setCropDimensions: Function, 
    setCanvasDimensions: Function,
    setCanvasInputValue: Function, 
    setCropValidation: Function, 
    setCropPosition: Function, 
    sendClickResset: Function, 
    
    dispatch: Function
    ) => {
  

    const resetWidth = Math.round(canvasWidth * 0.9),
      resetHeight = Math.round(canvasHeight * 0.9); 

      const cropPosition = getCropInitialPosition(canvasWidth, canvasHeight, resetWidth, resetHeight)

      sendClickResset();
      setCanvasInputValue({ width: resetWidth, height: resetHeight });
      dispatch(setCropDimensions(resetWidth, resetHeight));
      dispatch(setCropValidation({}));
      dispatch(setCropPosition(cropPosition.x, cropPosition.y));
};

const getCropInitialPosition = (canvasWidth, canvasHeight, resetWidth, resetHeight) => {
  return {x: canvasWidth / 2 - resetWidth / 2, y: canvasHeight / 2 - resetHeight / 2}
}

export const clickDownloadHandler = (image, type, name, service, properties, downloadImage, sendDownloadEvent) => {
    const imageNameWithFormt = 
        `${name.split(".").slice(0, -1).join(".")}.${type.split("/").pop().replace("jpeg", "jpg")}`
    
    sendDownloadEvent(service, properties);
    downloadImage(image, imageNameWithFormt);
}


export const showClearPopup = (showPopup, sendShowRemovePopup, dispatch) => {
    sendShowRemovePopup();
    dispatch(showPopup("clean_popup"));
};

export const clickCropHandler = (canvasImage, canvasRef, canvasWidth, canvasHeight, cropPosition, cropDimensions, canvasFormat, createImage, setCropValidation, changeImage, canvasSetDimension, setCanvasDimensions, sendClickCrop, setCropPosition, setCanvasInputValue, setCropDimensions, dispatch) => { 
    if(!canvasRef.current) return;

    createImage(canvasImage).then((image) => {
      canvasRef.current
        .getContext("2d")
        .drawImage(
          image,
          cropPosition.x,
          cropPosition.y,
          cropDimensions.width,
          cropDimensions.height,
          0,
          0,
          cropDimensions.width,
          cropDimensions.height
        );

      changeImage(canvasRef.current.toDataURL(canvasFormat));
    });

    const cropNewDimensionsWidth = Math.round(cropDimensions.width * 0.9);
    const cropNewDimensionsHeight = Math.round(cropDimensions.height * 0.9);

    dispatch(setCropValidation({}));

    dispatch( setCanvasDimensions(cropDimensions.height, cropDimensions.width));
    dispatch(canvasSetDimension(cropDimensions.height, cropDimensions.width));
    dispatch(setCropDimensions(cropNewDimensionsWidth, cropNewDimensionsHeight));
    dispatch(setCropPosition(cropDimensions.width / 2 - cropNewDimensionsWidth / 2, cropDimensions.height / 2 - cropNewDimensionsHeight / 2));
    
    setCanvasInputValue({width: cropNewDimensionsWidth, height: cropNewDimensionsHeight});
    sendClickCrop(canvasWidth, canvasHeight, cropDimensions.width, cropDimensions.height);
    
  };
  